import * as types from './types';
import actionCreatorFactory from 'typescript-fsa';
import { GenActionFactoryName } from 'shared/helpers/redux-helpers';
import { FeatureFlagsOptions } from 'shared/api/api';

const actionCreator = actionCreatorFactory(GenActionFactoryName('featureFlags'));

export const loadFeatureFlagsAsync = actionCreator.async<{}, FeatureFlagsOptions, { code: number; message: string }>(
	types.LOAD_FEATURE_FLAGS,
);
